import { render } from "./UserInfo.vue?vue&type=template&id=0a22f2cc&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=ts"
export * from "./UserInfo.vue?vue&type=script&lang=ts"

import "./UserInfo.vue?vue&type=style&index=0&id=0a22f2cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a22f2cc"

export default script